import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { CashbookTxnLineContainerModel } from '../../../../../../models/aggregates/erp/index';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class CashbookTxnLineService extends BaseApiTemplateService<CashbookTxnLineContainerModel> {
    
    readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txns/lines'

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txns/lines';
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-txns/lines';
        this.httpClient = http;
    }

    updateManulAdjActionCreateLink(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let customUrl;
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
          customUrl = this.apiUrl + '/update-cashbook-txn-line-create-adjustment-link/backoffice-ep';
        }
        return this.httpClient.put<ApiResponseModel<any>>(
          customUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

      updateManulAdjActionDeleteLink(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let customUrl;
        if (this.endpoint_path && visa.api_domain_url) {
          this.apiUrl = visa.api_domain_url + this.endpoint_path;
          customUrl = this.apiUrl + '/update-cashbook-txn-line-delete-adjustment-link/backoffice-ep';
        }
        return this.httpClient.put<ApiResponseModel<any>>(
          customUrl,
          dtoObject,
          this.getHttpHeader(visa)
        );
      }

      public getOpeningBalance(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url  + this.endpoint_path + "/calculate-opening-balance/backoffice-ep";
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
      }

    public getTotalBalance(payload: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
        let url;
        if (this.endpoint_path && visa.api_domain_url) {
          url = visa.api_domain_url  +  this.endpoint_path + "/calculate-total-balance/backoffice-ep";
        }
        return this.httpClient.post<ApiResponseModel<any>>(
          url,
          payload,
          this.getHttpHeader(visa)
        );
      }
    
}

